import { BaseService } from './base'
import { APIPath } from '../constant'

class MasterAnswers {
    getListsByCompany(companyId) {
        return BaseService.get(APIPath.masterAnswerListByCompany(companyId))
    }

    createList({ companyId, listName, listKey }) {
        return BaseService.postExact(APIPath.masterAnswerList, {
            CompanyId: companyId,
            ListName: listName,
            ListKey: listKey,
        })
    }

    updateList(listId, payload) {
        return BaseService.put(APIPath.masterAnswerListById(listId), payload)
    }

    getItems(listId) {
        return BaseService.get(APIPath.masterAnswerListItems(listId))
    }

    createItem(listId, item) {
        return BaseService.postExact(
            APIPath.masterAnswerListItems(listId),
            item,
        )
    }

    createItemsBulk(listId, items) {
        return BaseService.postExact(
            APIPath.masterAnswerListItemsBulk(listId),
            items,
        )
    }

    updateItem(listId, itemId, payload) {
        return BaseService.put(
            APIPath.masterAnswerListItem(listId, itemId),
            payload,
        )
    }

    deleteItem(listId, itemId) {
        return BaseService.remove(
            APIPath.masterAnswerListItem(listId, itemId),
        )
    }

    getMigrationOptionSets(companyId, templateIds) {
        const query =
            templateIds && templateIds.length
                ? `?templateIds=${templateIds.join(',')}`
                : ''
        return BaseService.get(
            `${APIPath.masterMigrationOptionSets(companyId)}${query}`,
        )
    }

    previewMigration(payload) {
        return BaseService.postExact(APIPath.masterMigrationPreview, payload)
    }

    commitMigration(payload) {
        return BaseService.postExact(APIPath.masterMigrationCommit, payload)
    }

    rollbackMigration(masterListId) {
        return BaseService.postExact(
            APIPath.masterMigrationRollback(masterListId),
            {},
        )
    }

    assignMasterListToQuestion(questionId, masterListId) {
        return BaseService.postExact(
            APIPath.templateQuestionAssignMasterList(
                questionId,
                masterListId,
            ),
            {},
        )
    }

    unassignMasterListFromQuestion(questionId) {
        return BaseService.remove(
            APIPath.templateQuestionUnassignMasterList(questionId),
        )
    }

    getMigrationHistory(companyId) {
        return BaseService.get(APIPath.masterMigrationHistory(companyId))
    }
}

export const MasterAnswersService = new MasterAnswers()
